<template>
  <div class="w-full h-full flex flex-col border-box relative">
    <apollo-mutation
      :mutation='saveToyMutation'
      class="flex pb-2 pt-2"
      fetch-policy='cache-and-network'
      :variables="{id,name,toy:toy,description,thumbnailImage,public:isPublic}">

      <template v-slot="{mutate,loading,error}">
        <loading v-if='loading' />
        <pbc-button @click='$emit("back")'>
          <chevron-left />
          <span class="mr-2">Back</span>
        </pbc-button>
        <div v-if='!loading' class="grow mx-2">
          <input v-model='name' :class="nameInputClasses" placeholder='Name' type="text" />
          <p v-if='validationError' class="text-red-500 text-xs italic">Please enter a name.</p>
          <input v-model='description' :class="nameInputClasses" placeholder='Description' type="text" />
        </div>
        <pbc-button @click='chooseImage = true'>
          <img :src='imageUrl' class="object-contain w-16 h-16" />
        </pbc-button>
        <toggle-switch v-model='isPublic' label='Public' />
        <pbc-button @click='mutate'>
          <post class="mx-2"/>
          <span class="mr-2">Save</span>
        </pbc-button>
      </template>
    </apollo-mutation>

    <choose-or-upload-image v-if='chooseImage' game-id='chezzer' @select='onSelectImage' />

    <!--
    <p v-if='validationErrorPostEmpty' class="text-red-500 text-xs italic">Your post is empty. Press the Add button to add a toy.</p>
    -->
    <editor class="grow relative"
            :transforms-and-source='transformsAndSource'
            :gamedata='transformsAndSource.gamedata.gamedata'
            background-color='#313131'
            />
    <fill-loader v-if='componentLoadingState[0]' />

    <pbc-message ref="message" />
  </div>
</template>
<script>
import Gamedata from '@edit/tree/gamedata.js';
import ChooseOrUploadImage from '@ui/organisms/ChooseOrUploadImage.vue';
import { ApolloMutation } from 'vue-apollo';
import ToyData from '@edit/tree/toydata.js';
import Post from '@icons/Post.vue';
import ChevronLeft from '@icons/ChevronLeft.vue';
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import uuid from 'uuid';
import ComponentLazyLoader from '@/lazyloader.js';
import { cloneDeep } from 'lodash';

import gql from 'graphql-tag';
//const {componentLoadingState, fn:UndoRenderer}  = ComponentLazyLoader(() => import(/* webpackChunkName: "edit" */ '@/edit/organisms/UndoRenderer.vue'));
const {componentLoadingState, fn:Editor}  = ComponentLazyLoader(() => import(/* webpackChunkName: "edit" */ '@/edit/organisms/Editor.vue'));

let dummyUserId = uuid.v4();

const saveToyMutation = gql(`
mutation saveToy($id: String!, $name: String!, $toy: String!, $description: String, $thumbnailImage: String, $public: Boolean) {
  saveToy(id: $id, name: $name, toy: $toy, description: $description, thumbnailImage: $thumbnailImage, public: $public) 
}
`);

export default {
  inject: ['api'],
  props: {
    toydata: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    thumbnailImage: {
      type: String,
      default: 'placeholder.png'
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSelectImage(img) {
      console.log('selected image', img);
      this.thumbnailImage = img.id;
      this.chooseImage = false;
    },
    getCleanedData() {
      return this.toy;
    }
  },
  data() {
    const id = this.toydata.id;
    const userId = dummyUserId;
    const DEFAULT_LAYERS = {
      id:'default'
    }
    const toydata = new ToyData(DEFAULT_LAYERS, this.toydata, true);
    const transformsAndSource = toydata.getTransformsAndSource();

    return {
      transformsAndSource,
      validationError:false,
      validationErrorPostEmpty:false,
      componentLoadingState,
      userId,
      id,
      chooseImage: false,
      saveToyMutation
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  components: {
    Editor,
    PbcMessage,
    Post,
    ChevronLeft,
    ApolloMutation,
    ChooseOrUploadImage
  },
  computed:{
    backgroundColor() {
      return this.gamedata.game.bgcolor.replace('0x', '#')
    },
    nameInputClasses() {
      const classes = ["pbc-standard-input", "text-lg", "my-1"];
      if (this.validationError) {
        classes.push("border-red-500 border border-2");
      }
      return classes;
    },
    toy() {
      return JSON.stringify(this.toydata);
    },
    imageUrl() {
      return this.api.makeImageUrlEditor(this.thumbnailImage);
    }
  },
  watch: {
    name(nv) {
      if (nv.length > 0) {
        this.validationError = false;
      }
    }
  }
}
</script>
